import { Tag } from '@servicetitan/design-system';
import styles from './TransferTag.module.css';
import classNames from 'classnames';

export const TransferTag = ({ className }: { className?: string }) => {
  return (
    <Tag
      className={classNames(styles.transferTag, className)}
      icon='compare_arrows'
      content=''
    >
      Transfer
    </Tag>
  );
};
